var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "quartz-core": "static-1.6389"
    },
    "depPathPrefixes": {
      "quartz-core": "/quartz-core/static-1.6389"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34783",
    "project": "quartz-core",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};